import { ResponseGetOrders } from '@vindr/services/apis/order.api';
import { Modal, Tabs } from 'antd';
import { MessageInstance } from 'antd/es/message/interface';
import { ModalStaticFunctions } from 'antd/es/modal/confirm';
import { useTranslation } from 'react-i18next';
import AssignedForm from './AssignedForm';
import AssigningForm from './AssigningForm';

const Assign = ({
  visible,
  order,
  onCancel,
  message,
  modal,
}: {
  visible: boolean;
  order: ResponseGetOrders['data']['0'];
  onCancel: () => void;
  message: MessageInstance;
  modal: Omit<ModalStaticFunctions, 'warn'>;
}) => {
  const { t } = useTranslation('Vindoc');

  const tabList = [
    {
      label: `Assigning`,
      key: 'assigning',
      children: (
        <AssigningForm order={order} onFinish={onCancel} onCancel={onCancel} message={message} />
      ),
    },
    {
      label: `Assigned`,
      key: 'assigned',
      children: (
        <AssignedForm
          order={order}
          // onFinish={onCancel}
          onCancel={onCancel}
          message={message}
          modal={modal}
        />
      ),
    },
  ];

  return (
    <Modal
      className="vindr-modal add-order max-w-screen w-[900px]"
      title={t('Assign Radiologist')}
      open={visible}
      maskClosable={false}
      destroyOnClose
      zIndex={1001}
      onCancel={onCancel}
      footer={null}
    >
      <Tabs defaultActiveKey="1" items={tabList} />
    </Modal>
  );
};

export default Assign;
